import React, { useState, useEffect, Fragment } from 'react';
import Traductor from '../Traductor';

import closeIconSVG from '../../images/icons/close-icon.svg';
import "../../css/components/preferences/modalExposureBrand.css";

function ModalExposureBrand({ closeModal }) {

    const t = new Traductor();

    return (
        <div className="c-modal" aria-hidden="false" id="modal-exposure-brand">
            <div className="c-modal__overlay  js-modal-close" tabIndex="-1"></div>
            <div className="c-modal__wrapper" role="dialog" aria-labelledby="modal-exposure-brand-title">
                <header className="c-modal__header">
                    <button className="c-modal__close-btn  js-modal-close" type="button" aria-label="Cerrar modal." onClick={() => closeModal({})}></button>
                    <div className="c-modal__title__wrapper">
                        <img src={closeIconSVG} style={{ height: "120px" }}></img>
                        <h1 className="c-modal__title" id="modal-exposure-brand-title"> {t.getTraduction("Oops")} </h1>
                    </div>
                </header>
                <div className="c-modal__content" role="document">
                    {t.getTraduction("ModalExposureBrand_body")}
                </div>
                <div className="c-modal__footer">
                    <div className="c-modal__actions">
                        <div className="c-modal__actions__item">
                            <button className="c-btn js-modal-close" aria-label="Cerrar modal" onClick={() => closeModal({})}>
                                <span className="c-btn__text">
                                    {t.getTraduction("Accept")}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalExposureBrand;
